import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { push, goBack } from 'react-router-redux';
import DictionaryGrid from '../../components/grids/DictionaryGrid';
import { saveDictionaryItem, deleteDictionaryItem, withRedirect } from '../../CroActions';
import { isLegitimate, isInternal } from '../../CroUtils';
import { breadcrumbs } from '../../../../actions/appActions';
import ShowOverviewHistoryButton from '../../components/audit/ShowOverviewHistoryButton';

// Form components

const initialValues = { order: 0, active: true };

export const createNewForm = (name, h1, url, form) => {
  const mapStateToPropsForm = () => ({
    breadcrumbsItems: [{ label: h1 }, { label: 'Nová položka' }],
    initialValues,
  });

  const onSubmit = withRedirect(saveDictionaryItem(url), `/spravce/ciselniky/${name}`);
  
  return connect(mapStateToPropsForm, { breadcrumbs, onSubmit, goBack })(form);
}

export const createEditForm = (name, h1, url, form) => {
  const mapStateToPropsForm = (state, { params, auth }) => ({
    breadcrumbsItems: [{ label: h1 }, { label: 'Editovat položku' }],
    initialValues,
    url: `${url}/${params.id}`,
    disabled: isLegitimate(auth),
});

  const onSubmit = withRedirect(saveDictionaryItem(url), `/spravce/ciselniky/${name}`);
  const onDelete = withRedirect(deleteDictionaryItem(url), `/spravce/ciselniky/${name}`);

  const mapDispatchToPropsForm = (dispatch, { params, auth }) => ({
    ...bindActionCreators({ breadcrumbs, onSubmit, goBack }, dispatch),
    onDelete: () => dispatch(onDelete(params.id)),
  })

  return connect(mapStateToPropsForm, mapDispatchToPropsForm)(form);
}

// Grid component

export const createGrid = (name, h1, url, columns) => {
  const mapStateToProps = (state, { auth }) => ({
    breadcrumbsItems: [{ label: h1 }],
    gridName: `dictionaryGrid_${name}`,
    url,
    columns,
    adding: isInternal(auth),
  });

  const mapDispatchToProps = (dispatch, { auth }) => ({
    ...bindActionCreators({ breadcrumbs }, dispatch),
    onAdd: () => dispatch(push(`${auth.startUrl}/ciselniky/${name}/form`)),
    onRowClick: data => dispatch(push(`${auth.startUrl}/ciselniky/${name}/form/${data.id}`)),
  })

  const ConnectedGrid = connect(mapStateToProps, mapDispatchToProps)(DictionaryGrid);

  return (props) => (
    <div>
      <ShowOverviewHistoryButton auth={props.auth} segment={`ciselniky/${name}`} />
      <ConnectedGrid {...props} />
    </div>
  );
}
